export const VISIBILITY_FILTER = {
    ALL: 'all',
    COMPLETED: 'completed',
    INCOMPLETED: 'remaining'
  }